import React from "react";
import { withRouter } from "react-router-dom";
import {
  MDBRow,
  MDBCol,
  MDBTableHead,
  MDBTable,
  MDBTableBody,
  MDBContainer,
  MDBSelect,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
} from "mdbreact";
import { connect } from "react-redux";
import { showHideLoader } from "../../../actions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { displayBreadcrumbs, showNotification } from "../../../actions";
import _ from "lodash";
import moment from "moment";
import { getLocationList } from "../../../actions/locationAction";
import { getLiveDashboard } from "../../../apis/BookingApi";
import LiveDashboardCounter from "../shared/LiveDashboardCounter";
import BookingEditor from "../shared/BookingEditor";
import { getStatuses } from "../../../actions/bookingAction";
import { getResource } from "../../../actions/resourceAction";
import { closeBooking } from "../../../actions";

class LiveDashboard extends React.Component {
  state = {
    tennisBookings: {},
    futsalBookings: {},
    statuses: {},
    selectedObj: {},
    locationResource: {},
    showChildModal: false,
    isPageLoaded: false,
    isUpdateTime: false,
  };

  constructor(props) {
    super(props);
  }

  // Async function to fetch data
  getLiveDashboardFunc = async (queryParams = {}) => {
    if (this.state.isPageLoaded == false) {
      this.props.showHideLoader(true);
    }
    try {
      let response = await getLiveDashboard(queryParams);

      this.setState({
        tennisBookings: response.data.resource_bookings?.[2] || [],
        futsalBookings: response.data.resource_bookings?.[1] || [],
      });
      // Handle the fetched data
      this.props.showHideLoader(false);
      this.setState({ isPageLoaded: true });
    } catch (error) {
      this.props.showNotification(
        "error",
        "Internal server error encountered. Please contact administrator."
      );
      this.props.showHideLoader(false);
    }
  };

  componentDidMount() {
    // this.props.showHideLoader(true);
    this.props.getLocationList({}, this.props.authUser.sessionToken);
    this.props.getStatuses(this.props.authUser.sessionToken);
    this.getLiveDashboardFunc();
    setInterval(() => this.getLiveDashboardFunc(), 10000);

    this.props.displayBreadcrumbs("Dashboard / Administrator / Live Dashboard");
  }

  getStatuses(prevProps, prevState) {
    if (
      prevProps.getStatusesSuccessResponse !==
        this.props.getStatusesSuccessResponse &&
      this.props.getStatusesSuccessResponse.status === 200
    ) {
      this.setState({
        statuses: this.props.getStatusesSuccessResponse.data.statuses,
      });
    }
  }

  getResourceResponse(prevProps, prevState) {
    if (
      (prevProps.getResourceResponse !== this.props.getResourceResponse &&
        this.props.getResourceResponse.status === 200) ||
      this.selectedObj
    ) {
      this.setState({
        locationResource: this.props.getResourceResponse.data,
        showChildModal: true,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.getStatuses(prevProps, prevState);
    this.getResourceResponse(prevProps, prevState);
    this.closeBooking(prevProps, prevState);
  }

  closeBooking(prevProps, prevState) {
    if (
      prevProps.isCloseBooking !== this.props.isCloseBooking &&
      this.props.isCloseBooking
    ) {
      this.props.closeBooking(false);

      this.setState({
        showChildModal: false,
        selectedObj: {},
        locationResource: {},
      });
    }
  }
  renderCardBody(data) {
    return (
      <>
        {data.is_current_booking ? (
          <>
            <p className="text-center">
              <strong>Duration:</strong>
              <LiveDashboardCounter
                duration={data.remaining_time.total_seconds}
                remaining_time_data={data.remaining_time}
              />
            </p>
            <p>
              <strong>Booking Reference:</strong> {data.booking_reference}
            </p>
            <p>
              <strong>Start Time:</strong> {data.start_time}
            </p>
            <p>
              <strong>End Time:</strong> {data.end_time}
            </p>
            <p>
              <strong>Amount to Pay:</strong> ${data.remaining_payment}
            </p>
            <p>
              <strong>Status:</strong> {data.status}
            </p>
            <p>
              <strong>Checked in participants:</strong>{" "}
              {data.participants.filter((p) => p.checked_in == 1).length} /{" "}
              {data.participants.length}
              <br />
              {data.participants.map((p) => {
                return (
                  <>
                    {p.checked_in ? (
                      <i className="fas fa-check-circle text-success"></i>
                    ) : (
                      <i className="fas fa-clock text-info"></i>
                    )}{" "}
                    {p.customer.firstName} {p.customer.lastName} <br />
                  </>
                );
              })}
            </p>
          </>
        ) : (
          <>
            <p className="text-center">
              <strong>Next booking in:</strong>
              <LiveDashboardCounter
                duration={data.remaining_time.total_seconds}
                remaining_time_data={data.remaining_time}
              />
            </p>
            <p>
              <strong>Booking Reference:</strong> {data.booking_reference}
            </p>
            <p>
              <strong>Start Time:</strong> {data.start_time}
            </p>
            <p>
              <strong>End Time:</strong> {data.end_time}
            </p>
            <p>
              <strong>Amount to Pay:</strong> ${data.remaining_payment}
            </p>
            <p>
              <strong>Status:</strong> {data.status}
            </p>
            <p>
              <strong>Participants:</strong> {data.participants.length}
              <br />
              {data.participants.map((p) => {
                return (
                  <>
                    {p.checked_in ? (
                      <i className="fas fa-check-circle text-success"></i>
                    ) : (
                      <i className="fas fa-clock text-info"></i>
                    )}{" "}
                    {p.customer.firstName} {p.customer.lastName} <br />
                  </>
                );
              })}
            </p>
          </>
        )}
      </>
    );
  }

  renderResourceCard(data) {
    let isExistingBooking = data.booking_data;
    return (
      <MDBCard className="mb-3  h-100 ">
        <MDBCardHeader style={{ backgroundColor: data.booking_color }}>
          <h3 className="text-white text-center font-weight-bold">
            {data.resource_name}
          </h3>
        </MDBCardHeader>
        <MDBCardBody
          className="d-flex flex-column justify-content-between"
          style={{ minHeight: "200px" }}
        >
          <div className="content-card w-100">
            {isExistingBooking ? (
              this.renderCardBody(data)
            ) : (
              <p className="text-center">
                <h5>
                  {" "}
                  <strong>No booking available</strong>
                </h5>
              </p>
            )}
          </div>
        </MDBCardBody>

        <MDBCardFooter
          style={{ backgroundColor: data.booking_color }}
          onClick={(e) => {
            if (isExistingBooking) {
              this.setState({
                selectedObj: data.booking_data,
              });
              this.props.getResource(
                data.booking_data.resource.uuid,
                this.props.authUser.sessionToken
              );
            }
          }}
        >
          <h5 className="text-white text-center font-weight-bold cursor-pointer hover-shadow">
            View more
          </h5>
        </MDBCardFooter>
      </MDBCard>
    );
  }

  renderBookingCardFutsal(data, index) {
    return (
      <MDBCol md="6" key={index} className="my-4">
        {this.renderResourceCard(data)}
      </MDBCol>
    );
  }

  renderBookingCardTennis(data, index) {
    return (
      <MDBCol md="4" key={index} className="my-4">
        {this.renderResourceCard(data)}
      </MDBCol>
    );
  }

  render() {
    const {
      tennisBookings,
      futsalBookings,
      statuses,
      locationResource,
      selectedObj,
      showChildModal,
    } = this.state;

    return (
      <>
        {showChildModal && (
          <div>
            <BookingEditor
              doCalculate={true}
              statuses={statuses}
              selectedBooking={selectedObj}
              locationResource={locationResource}
              isView={false}
            />
          </div>
        )}

        <MDBContainer className="my-4">
          <MDBRow className="my-4">
            <MDBCol md="12">
              <h3 className="text-center font-weight-bold  text-dark">
                Tennis Courts
              </h3>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            {tennisBookings.resources &&
              Object.values(tennisBookings.resources).map((resource, index) =>
                this.renderBookingCardTennis(resource, index)
              )}
          </MDBRow>

          <MDBRow className="my-4">
            <MDBCol md="12">
              <h3 className="text-center font-weight-bold text-dark">
                Futsal Fields
              </h3>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            {futsalBookings.resources &&
              Object.values(futsalBookings.resources).map((resource, index) =>
                this.renderBookingCardFutsal(resource, index)
              )}
          </MDBRow>
        </MDBContainer>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authUser: state.authUser,
    getLocationListSuccessResponse: state.getLocationListSuccessResponse,
    getLocationListFailedResponse: state.getLocationListFailedResponse,
    getStatusesSuccessResponse: state.getStatusesSuccessResponse,
    getResourceResponse: state.resourceResponse,
    isCloseBooking: state.closeBooking,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    displayBreadcrumbs,
    showHideLoader,
    showNotification,
    getLocationList,
    getStatuses,
    getResource,
    closeBooking,
  })(LiveDashboard)
);
